/**
 * Created by elmer on 29/06/17.
 */
import axios from 'axios';
import { getParsedFile } from './publicidad.utils';

export function campaigns(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get('/publicidadusuario').then((resp) => {
      context.commit('saveCampaigns', resp.data.registros);
      resolve(resp);
    }).catch((err) => {
      console.log('error al obtener las campañas');
    });
  });
}

export function publicidad(context, payload) {
  return new Promise((resolve, reject) => {
    axios.get(`/publicidad_archivos?populate=none&where={"idpublicidad":${payload.campaign.id}}`).then((resp) => {
      context.commit('setArchivosPublicidad', resp.data.registros.map(e => getParsedFile(e)));
      resolve(resp);
    }).catch((err) => {
      console.log('error al obtener los archivos de la campaña');
    });
  });
}

export function addPublicidad(context, payload) {
  return new Promise((resolve, reject) => {
    axios.post('/publicidad_archivos', payload.form).then((resp) => {
      return axios.get(`/publicidad_archivos/${resp.data.id}?populate=none`);
    }).then((upload) => {
      setTimeout(() => {
        context.commit('addUpload', getParsedFile(upload.data));
        resolve(upload.data);
      }, 3500);
    });
  });
}

export function editPublicidad(context, payload) {
  return new Promise((resolve, reject) => {
    axios.put(`/publicidad_archivos/${payload.id}`, payload.form).then((resp) => {
      return axios.get(`/publicidad_archivos/${resp.data.id}?populate=none`);
    }).then((upload) => {
      setTimeout(() => {
        context.commit('editUpload', {
          id: payload.id,
          data: getParsedFile(upload.data),
        });
        resolve(upload.data);
      }, 2000);
    });
  });
}

export function togglePublicidad(context, payload) {
  return new Promise((resolve, reject) => {
    axios.put(`/publicidad_archivos/${payload.item.id}`, {
      estado: payload.estado,
    }).then((resp) => {
      context.commit('togglePublicidad', payload);
      resolve(resp);
    });
  });
}

export function removePublicidad(context, payload) {
  return new Promise((resolve, reject) => {
    axios.delete(`publicidad_archivos/${payload.upload.id}`).then((resp) => {
      context.commit('removeUpload', payload.upload);
      resolve(resp);
    });
  });
}

export function removeCatchedFile(context, payload) {
  return axios.get(`/api/removeCatchedFile?tabla=publicidad_archivos&url_archivo_temporal=${payload.nombre_temporal}`);
}



// WEBPACK FOOTER //
// ./src/modules/admin/publicidad.actions.js